const items = [
  {
    quote:
      "FIS replaced three vendors for us. We hired two staff engineers, shipped a new customer portal and deployed a support bot — same quarter.",
    name: "Priya Menon",
    role: "VP Engineering, a Series-B fintech",
  },
  {
    quote:
      "The chatbot they built deflects 41% of our tier-1 tickets and actually sounds like our brand. We now run it as a product surface.",
    name: "Daniel Rhee",
    role: "Head of CX, global D2C",
  },
  {
    quote:
      "Calm, fast, senior. The kind of partner that makes your CTO look good and your CFO relaxed.",
    name: "Anika Varma",
    role: "COO, healthtech platform",
  },
];

export default function Testimonials() {
  return (
    <section
      data-testid="testimonials-section"
      className="max-w-[1440px] mx-auto px-6 md:px-12 py-24 md:py-32"
    >
      <div className="grid grid-cols-1 md:grid-cols-12 gap-8 mb-16">
        <div className="md:col-span-6">
          <div className="font-mono-label mb-4">§ 04 — Signal</div>
          <h2 className="font-display text-5xl md:text-7xl">
            What clients
            <br />
            actually say.
          </h2>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {items.map((t, i) => (
          <figure
            key={i}
            data-testid={`testimonial-${i}`}
            className="fis-cell p-8 md:p-10 flex flex-col min-h-[320px]"
          >
            <div className="font-display text-4xl text-[color:var(--fis-accent)] leading-none">
              “
            </div>
            <blockquote className="mt-4 text-lg leading-relaxed">
              {t.quote}
            </blockquote>
            <figcaption className="mt-auto pt-8 border-t fis-hairline">
              <div className="font-medium">{t.name}</div>
              <div className="font-mono-label mt-1">{t.role}</div>
            </figcaption>
          </figure>
        ))}
      </div>
    </section>
  );
}
